import { CustomConfirmDialogComponent } from "./../../../shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { InventoryItemsForMiscComponent } from "src/app/shared/components/inventory-items-for-misc/inventory-items-for-misc.component";
import { InventoryItemsForPurchaseComponent } from "src/app/shared/components/inventory-items-for-purchase/inventory-items-for-purchase.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { AuthService } from "src/app/providers/auth.service";
import { PurchasePaymentRecordComponent } from "../../new-v2-pages/new-v2-component/purchase-payment-record/purchase-payment-record.component";

@Component({
  selector: "sm-purchase-list",
  templateUrl: "./purchase-list.component.html",
  styleUrls: ["./purchase-list.component.scss"],
})
export class PurchaseListComponent implements OnInit, OnDestroy {
  overview: any;
  monthlyPurchase: number = 0;
  todayPurchase: number = 0;
  purchaseListData: any[] = [];
  tableDisplayColumn: ITableColumnHeader[] = [
    {
      columnName: 'Date',
      columnProperty: "duty_time",
    },
    {
      columnName: 'Item Name',
      columnProperty: "item_name",
    },
    {
      columnName: 'Purchase Amount',
      columnProperty: "purchase_quantity",
    },
    {
      columnName: 'Purchase Unit',
      columnProperty: "purchase_unit",
    },
    {
      columnName: 'Purchase Price',
      columnProperty: "pprice",
    },
    {
      columnName: 'Amount due',
      columnProperty: "adue",
    },
    // {
    //   columnName: "status",
    //   columnProperty: "p_status"
    // },
    // {
    //   columnName: "activity type",
    //   columnProperty: "activity_type"
    // }
  ];
  entityHashId: string = "";
  entityHashIdForSearch: string = "";
  datalength!: number;
  public page: number = 1;
  public loader: boolean = false;
  _apiSubscription: Subscription;
  loaded: boolean = false;
  constructor(
    private translateService: TranslateService,
    private dialog: MatDialog,
    private _navService: NavigationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    private route: ActivatedRoute,
    private _modelRef: MatDialog,
    private authService: AuthService
  ) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData) {
        if (
          resData.responseType === SM_CONSTANTS.RESULT_API_ENTITY_PURCHASE_ITEMS
        ) {
          this.purchaseListData = [];
          if (resData.result && resData.result != "null") {
            this.purchaseListData = resData.result;
            this.purchaseListData = resData.result.map((item: any) => {
              // Creating a new object with all the same keys and values
              const newItem = { ...item };

              // Adding a new custom key with a custom value
              newItem.p_status =
                item.purchase_status == 1
                  ? "Completed"
                  : item.purchase_status == 2
                  ? "Reminder"
                  : "Cancelled";
              newItem.pprice = item.currency_symbol + item.purchase_price.toFixed(2);
              newItem.duty_time = item.creation_time
              if(item.amount_due){
                newItem.adue = item.currency_symbol + item.amount_due.toFixed(2);

              }
              else{
                newItem.adue = item.currency_symbol + '0.00'
              }

              return newItem;
            });
          }

          this.loader = false;
          this.loaderservice.showLoader = false;
        } else if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_ADD_EDIT_PURCHASE_ITEM
        ) {
          if (resData.result && resData.result != null) {
            this._apiService.getEntityPurchaseItems(
              this.entityHashId,
              this.page.toString()
            );
            this._apiService.getEntityPurchaseOverview(this.entityHashId);
          }
        } else if (
          resData.responseType ===
          SM_CONSTANTS.RESULT_API_ENTITY_PURCHASE_OVERVIEW
        ) {
          this.overview = null;
          if (resData.result && resData.result != null) {
            this.overview = resData.result[0];
            // this._apiService.getEntityPurchaseItems(this.entityHashId, this.page.toString())
            this.monthlyPurchase = resData.result[0].monthPurchase ?? 0;
            this.todayPurchase = resData.result[0].dailyPurchase ?? 0;
            this.loaded = false;
          }
          console.log(this.overview);
        }
        this.translateService.onLangChange.subscribe(() => {
          // Update your column headers when the language changes
          this.updateColumnHeaders();
        });
      }
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumn.forEach((column, index) => {
      let data = ["date", "name", "amount", "unit", "price"];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `purchases.column_headers.${data[index]}`
      );
    });
  }
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      // this.entityHashIdForSearch = data.entityHash
    });

    // this.loaded = true
    this._apiService.getEntityPurchaseOverview(this.entityHashId);
    this._apiService.getEntityPurchaseItems(
      this.entityHashId,
      this.page.toString()
    );
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
  openInventoryItems() {
    this._modelRef.open(InventoryItemsForPurchaseComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Inventory items",
        operation_type: 1,
        ref: this._modelRef,
        toShowTemplate: true,
      },
      // disableClose : true
    });
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    this._apiService.getEntityInventoryInOutData(
      this.entityHashId,
      this.page.toString()
    );
  }

  // onRecordUsageAndFinish(){
  //   // this.loaderservice.showLoader = true;
  //   this._modelRef.open(InventoryItemsForMiscComponent, {
  //         width: '1000px',
  //         minWidth: "400px",
  //         data: {
  //           title: 'Record usage/finish',
  //           ref: this._modelRef,
  //         },
  //       });
  //     }
  onRevertUsage(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message:
          "This will remove the usage record and increase the stock as well. Are you sure you want to continue?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodyData = {
          entity_hash_id: this.entityHashId,
          itemHashId: rowvalue.item_hash_id,
          activityHashId: rowvalue.hash_id,
        };
        // this.loader = true;
        this.loaderservice.showLoader = true;
        this._apiService.editInventoryActivity(bodyData);
      }
    });
  }

  onRecordUsage() {
    this._modelRef.open(InventoryItemsForMiscComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Inventory items",
        operation_type: 2,
        ref: this._modelRef,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }

  onEdit(rowvalue: any) {
    this._modelRef.open(InventoryItemsForPurchaseComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Purchase Item",
        operation_type: 2, //edit
        ref: this._modelRef,
        purchaseData: rowvalue,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }
  markPurchased(rowvalue: any) {
    this._modelRef.open(InventoryItemsForPurchaseComponent, {
      // width: '1000px',
      // minWidth: "400px",
      data: {
        title: "Purchase Item",
        operation_type: 3, //mark purchased
        ref: this._modelRef,
        purchaseData: rowvalue,
        toShowTemplate: true,
      },
      disableClose: true,
    });
  }
  OnIncreaseStock() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Stock update will only increase your initial item quantity counts. It's not going to add any purchase/price related data. If you have purchased the item(s), add the record from the Purchase section.",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        this._modelRef.open(InventoryItemsForMiscComponent, {
          // width: '1000px',
          // minWidth: "400px",
          data: {
            title: "Inventory items",
            operation_type: 1,
            ref: this._modelRef,
            toShowTemplate: true,
          },
          disableClose: true,
        });
      }
    });
  }

  onPurchasePending(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to change the status of this purchase to pending? Your inventory stock count may be affected if it was previously marked purchased.",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodydata = {
          hash_id: rowvalue.purchase_hash_id,
          entity_hash_id: rowvalue.entity_hash_id,
          inv_item_hash: rowvalue.inventory_item_hash_id,
          purchase_qty: rowvalue.purchase_quantity,
          purchase_unit: rowvalue.purchase_unit,
          purchase_status: 2, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: rowvalue.purchase_price,
          notes: rowvalue.notes,
          status: rowvalue.status,
          purchase_date: this.formatDate(
            new Date(rowvalue.purchase_date).toLocaleDateString()
          ),
          "createdByHash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), 
          "createdByemployeeHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID), 
          "creatorByType": this.isOwner ? 1 : 2,
          "selling_qty": rowvalue.selling_quantity,
          "selling_unit": rowvalue.selling_unit,
          "selling_purchase_multiplier": rowvalue.selling_purchase_multiplier,
        };

        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    });
  }
  onPurchaseCancelled(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to cancel this item from purchase list?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodydata = {
          hash_id: rowvalue.purchase_hash_id,
          entity_hash_id: rowvalue.entity_hash_id,
          inv_item_hash: rowvalue.inventory_item_hash_id,
          purchase_qty: rowvalue.purchase_quantity,
          purchase_unit: rowvalue.purchase_unit,
          purchase_status: 3, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: rowvalue.purchase_price,
          notes: rowvalue.notes,
          status: rowvalue.status,
          purchase_date: rowvalue.purchase_date
            ? this.formatDate(
                new Date(rowvalue.purchase_date).toLocaleDateString()
              )
            : null,
          "createdByHash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), 
          "createdByemployeeHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID), 
          "creatorByType": this.isOwner ? 1 : 2,
          "selling_qty": rowvalue.selling_quantity,
          "selling_unit": rowvalue.selling_unit,
          "selling_purchase_multiplier": rowvalue.selling_purchase_multiplier,
        };
        Object.keys(bodydata).forEach((key) => {
          if ((bodydata as any)[key] === null) {
            delete (bodydata as any)[key];
          }
        });
        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    });
  }
  onPurchaseDeleted(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to delete this item from purchase list?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result);
      if (result) {
        let bodydata = {
          hash_id: rowvalue.purchase_hash_id,
          entity_hash_id: rowvalue.entity_hash_id,
          inv_item_hash: rowvalue.inventory_item_hash_id,
          purchase_qty: rowvalue.purchase_quantity,
          purchase_unit: rowvalue.purchase_unit,
          purchase_status: 0, //1 = purchase, 2=reminder,3 = cancelled,0=delete
          purchase_price: rowvalue.purchase_price,
          notes: rowvalue.notes,
          status: rowvalue.status,
          purchase_date: rowvalue.purchase_date
            ? this.formatDate(
                new Date(rowvalue.purchase_date).toLocaleDateString()
              )
            : null,
          "createdByHash": localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID), 
          "createdByemployeeHash": localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID), 
          "creatorByType": this.isOwner ? 1 : 2,
          "selling_qty": rowvalue.selling_quantity,
          "selling_unit": rowvalue.selling_unit,
          "selling_purchase_multiplier": rowvalue.selling_purchase_multiplier,
        };
        Object.keys(bodydata).forEach((key) => {
          if ((bodydata as any)[key] === null) {
            delete (bodydata as any)[key];
          }
        });
        this.loaderservice.showLoader = true;
        this._apiService.addEditPurchaseItem(bodydata);
      }
    });
  }

  formatDate(dateStr: string) {
    // Split the date string by `/`
    const parts = dateStr.split("/");

    // Reverse the order of the parts and join them with `-`
    const newDateStr = parts.reverse().join("-");

    // Return the formatted date string
    return newDateStr;
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "",
        title: "Business profile",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }

  checkDisablity(item:any){
    if(this.isOwner){
      return false
    }
    else{
      if(item.created_by == localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) && item.modified_by == localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)){
        return false
      }
      else{
        return true
      }
    }
  }

  recordPayment(item:any){
    let dialogref = this.dialog.open(PurchasePaymentRecordComponent,{
      width: '400px',
      data:{
        data:item
      }
    })
    dialogref.afterClosed().subscribe(data => {
      if(data){
        this._apiService.getEntityPurchaseOverview(this.entityHashId);
        this._apiService.getEntityPurchaseItems(
          this.entityHashId,
          this.page.toString()
        );
      }
    })
  }


  openLinkURL(rowvalue: any): void {
    if (!rowvalue) return;

    let url = String(rowvalue).trim();

    // Check if the URL starts with http:// or https://
    // If not, prepend https:// to make it absolute
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    window.open(url, '_blank');
  }
}
